export default __webpack_public_path__ + "static/media/vicunas.c961668b.jpg";